import { createContext, useContext } from 'react';
export const SubscriptionScreenContext = createContext({});
export const useSubscriptionScreenContext = () => useContext(SubscriptionScreenContext);
